import { useQuery } from 'react-query'
import { performanceService } from '../services/performanceService'

export function usePerformance(
  dataInicio: string | undefined,
  dataFim: string | undefined,
  idTime: number | undefined
) {
  return useQuery(
    ['performance', dataInicio, dataFim, idTime],
    () => performanceService.obter(dataInicio!, dataFim!, idTime),
    { enabled: !!dataInicio && !!dataFim, staleTime: 2 * 60 * 1000 }
  )
}
